import BarChart from './BarChart';
import XLoader from '../../../../components/common/XLoader';
import CardHeader from "../../../superAdmin/components/common/CardHeader";
import { useCompanySalesContext } from "../../../superAdmin/superdashboard/context/CompanySalesContext";
import { pieCardClasses, pieContentClasses } from '../../../../components/common/dashboardClasses';
import { costTotalTextClasses, costAmountClasses } from '../../../../components/common/dashboardGridClasses';

const SignupCountGraph = () => {

  const {
    totalSignups,
    isLoading,
    chartData,
    interval
  } = useCompanySalesContext();

  const rightSection = (
    <div className={costTotalTextClasses}>
      <span className={`${costAmountClasses} ml-2`}>
        Total: {totalSignups} signups ({interval})
      </span>
    </div>
  );

  return (
    <div className={pieCardClasses}>
      <CardHeader
        title="Monthly Signup Volume"
        rightContent={rightSection}
      />

      <div className={`${pieContentClasses} text-center`}>
        {isLoading ? (
          <XLoader />
        ) : (
          <BarChart dataPoints={chartData} width={400} height={240} />
        )}
      </div>
    </div>
  );
};

export default SignupCountGraph;
